import { useTheme } from "../../theme/Theme";

export function DownloadIcon({ color, sx, ...props }: Application.IconProps) {
  const theme = useTheme();
  const iconColor = theme.palette.gary.main;

  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.12072 15.1303L6.41978 13.7695C6.14758 14.5745 6 15.4369 6 16.3337C6 20.752 9.58172 24.3337 14 24.3337C18.4183 24.3337 22 20.752 22 16.3337C22 15.4369 21.8524 14.5745 21.5802 13.7695L19.8793 15.1303C19.9584 15.5191 20 15.9215 20 16.3337C20 19.6474 17.3137 22.3337 14 22.3337C10.6863 22.3337 8 19.6474 8 16.3337C8 15.9215 8.04156 15.5191 8.12072 15.1303Z"
        fill={iconColor}
      />
      <path
        d="M8.16699 10.4993L14.0003 15.166M14.0003 15.166L19.8337 10.4993M14.0003 15.166L14.0003 4.66602"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
